if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production' || process.env.SW_DEV) {
    const serviceWorkerPath = `${process.env.PUBLIC_PATH}service-worker.js`;
    navigator.serviceWorker
      .register(serviceWorkerPath, { scope: '/' })
      .catch((error) => {
        console.error(`Service worker registration failed (${serviceWorkerPath}):`, error);
      });
  }
}
